import { Component, Input, EventEmitter, Output } from '@angular/core';
import { DashboardResponse } from '../../../../api/models/dashboardResponse';

@Component({
    selector: 'qvrejected-aged-expired2',
    template: require('./qvrejected-aged-expired2.component.html')
})

export class QVRejectedAgedExpired2Component {

    public ham: boolean = false;
    public paramsUrl: string = '?loc=en_US&placardid=';
    phoneNumberFixed: string = '';

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;
    @Output() placardIdDetail = new EventEmitter<string>();

    constructor() {
        /* empty */
    }

    ngOnInit() {
        if (this.dataSearch.phoneNumber != undefined && this.dataSearch.phoneNumber != null) {
            this.phoneNumberFixed = this.dataSearch.phoneNumber.substr(15, 14).split('-').join('');
        }
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        // Call API for search Information
    }
    showDetail(placardId: string) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }
}